export default __webpack_public_path__ + "static/media/Catamaran-ExtraLight.baaedf30.ttf";